// extracted by mini-css-extract-plugin
export default {"priority-switch":"PromiseList_priority-switch__0IhzY","infooutlined-alignment":"PromiseList_infooutlined-alignment__u5ynO"};